import MoreLikeThis from './more-like-this';

export default MoreLikeThis;
